/* eslint-disable react/prop-types */
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, formatNumber } from "redux/action/api";
import { postApi } from "redux/action/api_tbeams";
import { resolveFileUrl } from "redux/action/fileUpload";
import { useSelector } from "react-redux";
import { useToasts } from "helper/ToastAdapter";
import {
  Button,
  Card,
  Col,
  Row,
  Spinner,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";

export default function ViewMemo() {
  const navigate = useNavigate();
  const query = useQuery();
  const id = query.get("id");
  const memoType = query.get("memoType");
  const req_status = query.get("status");
  const display = query.get("display"); 
  const user = useSelector((e) => e.auth.user);
  const { addToast } = useToasts();

  const [memo, setMemo] = useState(null);
  const [budgetAmount, setBudgetAmount] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [modal, setModal] = useState(false);
  const [actionType, setActionType] = useState("");
  const [remarks, setRemarks] = useState("");

  const toggle = () => setModal(!modal);

  const getMemo = useCallback(() => {
    setIsLoading(true);
    postApi("memo/get", { id, role: user?.role })
      .then((data) => {
        if (data.result) {
          console.log("Memo data:", data.result);
          setMemo(data.result);
          // Fetch budget balance
          postApi(`update_budget_balance`, {
            query_type: "select",
            mda_name: data.result.mda_name,
            mda_code: data.result.mda_code,
            amount: null,
            economic_code: data.result.economic_code,
            program_code: data.result.program_code,
          })
            .then((d) => {
              if (d.success && d.data?.[0]) {
                setBudgetAmount(d.data[0]);
              }
            })
            .catch(console.log);
        }
      })
      .catch(console.log)
      .finally(() => setIsLoading(false));
  }, [id, user?.role]);

  useEffect(() => {
    getMemo();
  }, [getMemo]);

  const openActionModal = (type) => {
    setActionType(type);
    setRemarks("");
    toggle();
  };

  const handleAction = async () => {
    if (!remarks.trim()) {
      addToast("Please enter remarks", { appearance: "error", autoDismiss: true });
      return;
    }
    setSubmitting(true);
    try {
      const resp = await postApi("memo/update-status", {
        id,
        status: actionType,
        remarks,
        approved_by: user?.username,
        memoType: memoType,
      });
      if (resp.success) {
        addToast(`Memo ${actionType.toLowerCase()} successfully`, {
          appearance: "success",
          autoDismiss: true,
        });
        navigate(-1)
        toggle();
        getMemo();
      } else {
        addToast(resp.error || "Action failed", { appearance: "error", autoDismiss: true });
      }
    } catch (err) {
      addToast("An error occurred", { appearance: "error", autoDismiss: true });
    } finally {
      setSubmitting(false);
    }
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "Approved":
        return { color: "green", fontWeight: "bold" };
      case "Rejected":
        return { color: "red", fontWeight: "bold" };
      default:
        return { color: "orange", fontWeight: "bold" };
    }
  };

  if (isLoading) {
    return (
      <DashboardLayout>
        <MDBox pt={2} pb={3} pl={2} className="text-center">
          <Spinner color="primary" />
        </MDBox>
      </DashboardLayout>
    );
  }

  if (!memo) {
    return (
      <DashboardLayout>
        <MDBox pt={2} pb={3} pl={2}>
          <p>Memo not found</p>
        </MDBox>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <MDBox pt={2} pb={3} pl={2} pr={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h5" color="white">
                  Memo Details
                </MDTypography>
                <MDBox
                  px={2}
                  py={1}
                  borderRadius="lg"
                  style={{
                    backgroundColor: getStatusStyle(memo.status).color,
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  {memo.status}
                </MDBox>
              </MDBox>
              {/* {JSON.stringify(memo)} */}

              <MDBox p={3}>
                <Row>
                  <Col md={6}>{/* Budget Classification Section */}
                <MDBox mb={3} p={2} style={{ backgroundColor: "#f5f5f5", borderRadius: "8px" }}>
                  <MDTypography variant="h6" style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    Budget Classification
                  </MDTypography>
                  <Row>
                    <Col md={6}>
                      <MDBox mb={2}>
                        <MDTypography variant="caption" style={{ color: "#666", fontSize: "12px" }}>
                          ECONOMIC CODE
                        </MDTypography>
                        <MDTypography variant="body2" style={{ fontWeight: "500" }}>
                          {memo.economic_code} - {memo.economic_description}
                        </MDTypography>
                      </MDBox>
                    </Col>
                    <Col md={6}>
                      <MDBox mb={2}>
                        <MDTypography variant="caption" style={{ color: "#666", fontSize: "12px" }}>
                          PROGRAM CODE
                        </MDTypography>
                        <MDTypography variant="body2" style={{ fontWeight: "500" }}>
                          {memo.program_code} - {memo.program_description}
                        </MDTypography>
                      </MDBox>
                    </Col>
                  </Row>
                </MDBox></Col>
                  <Col md={6}>{/* MDA Section */}
                <MDBox mb={3} p={2} style={{ backgroundColor: "#f5f5f5", borderRadius: "8px" }}>
                  <MDTypography variant="h6" style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    Organization Information
                  </MDTypography>
                  <Row>
                    <Col md={6}>
                      <MDBox mb={2}>
                        <MDTypography variant="caption" style={{ color: "#666", fontSize: "12px" }}>
                          MDA CODE
                        </MDTypography>
                        <MDTypography variant="body2" style={{ fontWeight: "500" }}>
                          {memo.mda_code}
                        </MDTypography>
                      </MDBox>
                    </Col>
                    <Col md={6}>
                      <MDBox mb={2}>
                        <MDTypography variant="caption" style={{ color: "#666", fontSize: "12px" }}>
                          MDA NAME
                        </MDTypography>
                        <MDTypography variant="body2" style={{ fontWeight: "500" }}>
                          {memo.mda_name}
                        </MDTypography>
                      </MDBox>
                    </Col>
                  </Row>
                </MDBox></Col>
                  <Col md={6}> {/* Amount Section */}
                <MDBox mb={3} p={2} style={{ backgroundColor: "#f5f5f5", borderRadius: "8px" }}>
                  <MDTypography variant="h6" style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    Financial Information
                  </MDTypography>
                  <Row>
                    <Col md={4}>
                      <MDBox mb={2}>
                        <MDTypography variant="caption" style={{ color: "#666", fontSize: "12px" }}>
                          MEMO AMOUNT
                        </MDTypography>
                        <MDTypography variant="body2" style={{ fontWeight: "bold", color: "#1976d2" }}>
                          {formatNumber(memo.amount)}
                        </MDTypography>
                      </MDBox>
                    </Col>
                    <Col md={4}>
                      <MDBox mb={2}>
                        <MDTypography variant="caption" style={{ color: "#666", fontSize: "12px" }}>
                          BUDGET AMOUNT
                        </MDTypography>
                        <MDTypography variant="body2" style={{ fontWeight: "500" }}>
                          {formatNumber(budgetAmount?.approve_amount || 0)}
                        </MDTypography>
                      </MDBox>
                    </Col>
                    <Col md={4}>
                      <MDBox mb={2}>
                        <MDTypography variant="caption" style={{ color: "#666", fontSize: "12px" }}>
                          BALANCE
                        </MDTypography>
                        <MDTypography
                          variant="body2"
                          style={{
                            fontWeight: "bold",
                            color: budgetAmount?.mopb_balance > 0 ? "green" : "red",
                          }}
                        >
                          {formatNumber(budgetAmount?.mopb_balance || 0)}
                        </MDTypography>
                      </MDBox>
                    </Col>
                  </Row>
                </MDBox></Col>
                  <Col md={6}> {/* Description Section */}
                <MDBox mb={3} p={2} style={{ backgroundColor: "#f5f5f5", borderRadius: "8px" }}>
                  <MDTypography variant="h6" style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    Description
                  </MDTypography>
                  <MDTypography variant="body2" style={{ lineHeight: "1.6" }}>
                    {memo.description}
                  </MDTypography>
                </MDBox>
                </Col>
                  <Col md={6}>{/* Audit Trail Section */}
                <MDBox mb={3} p={2} style={{ backgroundColor: "#f5f5f5", borderRadius: "8px" }}>
                  <MDTypography variant="h6" style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    Audit Trail
                  </MDTypography>
                  <Row>
                    <Col md={6}>
                      <MDBox mb={2}>
                        <MDTypography variant="caption" style={{ color: "#666", fontSize: "12px" }}>
                          CREATED BY
                        </MDTypography>
                        <MDTypography variant="body2" style={{ fontWeight: "500" }}>
                          {memo.created_by}
                        </MDTypography>
                      </MDBox>
                    </Col>
                    <Col md={6}>
                      <MDBox mb={2}>
                        <MDTypography variant="caption" style={{ color: "#666", fontSize: "12px" }}>
                          MEMO DATE
                        </MDTypography>
                        <MDTypography variant="body2" style={{ fontWeight: "500" }}>
                          {memo.memo_date}
                        </MDTypography>
                      </MDBox>
                    </Col>
                  </Row>
                  {memo.approved_by && (
                    <Row>
                      <Col md={6}>
                        <MDBox mb={2}>
                          <MDTypography variant="caption" style={{ color: "#666", fontSize: "12px" }}>
                            APPROVED/REJECTED BY
                          </MDTypography>
                          <MDTypography variant="body2" style={{ fontWeight: "500" }}>
                            {memo.approved_by}
                          </MDTypography>
                        </MDBox>
                      </Col>
                      <Col md={6}>
                        <MDBox mb={2}>
                          <MDTypography variant="caption" style={{ color: "#666", fontSize: "12px" }}>
                            APPROVAL DATE
                          </MDTypography>
                          <MDTypography variant="body2" style={{ fontWeight: "500" }}>
                            {memo.approved_date}
                          </MDTypography>
                        </MDBox>
                      </Col>
                    </Row>
                  )}
                </MDBox></Col>
                  
               

                <Col md={6}>
 <MDBox mb={3} p={2} style={{ backgroundColor: "#f5f5f5", borderRadius: "8px" }}>
                  <MDTypography variant="h6" style={{ marginBottom: "10px", fontWeight: "bold" }}>
                    Last Remark
                  </MDTypography>
                  <MDTypography variant="body2" style={{ lineHeight: "1.6" }}>
                    {memo.remarks}
                  </MDTypography>
                </MDBox>
                {/* Attachment Section */}
                {memo.document_path && (
                  <MDBox mb={3} p={2} style={{ backgroundColor: "#e3f2fd", borderRadius: "8px", borderLeft: "4px solid #2196f3" }}>
                    <MDTypography variant="h6" style={{ marginBottom: "10px", fontWeight: "bold" }}>
                      Attachment
                    </MDTypography>
                    <Button
                      color="info"
                      size="sm"
                      href={resolveFileUrl(memo.document_path)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      📄 View Document
                    </Button>
                  </MDBox>
                )}
</Col>
              
                </Row>
                

                

               

               

                
                {/* Action Buttons */}
                <MDBox mt={4} display="flex" gap={2}>
                  <Button color="secondary" onClick={() => navigate(-1)}>
                    ← Back to List
                  </Button>
                  {memoType === "Secretary" && req_status !=="Rejected" || display === "false" ? null :(
                    <>
                      <Button color="success" onClick={() => openActionModal("Approved")}>
                        ✓ Approve
                      </Button>
                      <Button color="danger" onClick={() => openActionModal("Rejected")}>
                        ✕ Reject
                      </Button>
                    </>
                  )}
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {actionType === "Approved" ? "Approve Memo" : "Reject Memo"}
        </ModalHeader>
        <ModalBody>
          <Label>Remarks *</Label>
          <Input
            type="textarea"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            rows={4}
            placeholder="Enter your remarks"
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            color={actionType === "Approved" ? "success" : "danger"}
            onClick={handleAction}
            disabled={submitting}
          >
            {submitting ? <Spinner size="sm" /> : actionType === "Approved" ? "Approve" : "Reject"}
          </Button>
        </ModalFooter>
      </Modal>
    </DashboardLayout>
  );
}
